var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"day-of-week"},_vm._l((_vm.weekdays),function(weekday){return _c('li',{key:weekday},[_vm._v(" "+_vm._s(weekday)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }